import { defineMessages } from 'react-intl';

export const LandingSnackbarTranslations = defineMessages({
  draftSaved: {
    id: 'LandingSnackbar.draftSaved',
    defaultMessage: 'Votre message a bien été enregistré, inscrivez-vous pour pouvoir l’envoyer',
  },
});
